/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAccount } from './GoogleAccount';
import {
    GoogleAccountFromJSON,
    GoogleAccountFromJSONTyped,
    GoogleAccountToJSON,
    GoogleAccountToJSONTyped,
} from './GoogleAccount';

/**
 * 
 * @export
 * @interface GoogleCalendar
 */
export interface GoogleCalendar {
    /**
     * The unique identifier for this calendar
     * @type {string}
     * @memberof GoogleCalendar
     */
    id: string;
    /**
     * the GoogleAccount that owns this Calendar
     * @type {GoogleAccount}
     * @memberof GoogleCalendar
     */
    account: GoogleAccount;
    /**
     * The summary/title of the calendar
     * @type {string}
     * @memberof GoogleCalendar
     */
    summary: string;
    /**
     * A description for this calendar
     * @type {string}
     * @memberof GoogleCalendar
     */
    description: string;
    /**
     * The IANA timezone of the calendar
     * @type {string}
     * @memberof GoogleCalendar
     */
    timezone: string;
    /**
     * Whether this calendar is enabled for public access
     * @type {boolean}
     * @memberof GoogleCalendar
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GoogleCalendar interface.
 */
export function instanceOfGoogleCalendar(value: object): value is GoogleCalendar {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GoogleCalendarFromJSON(json: any): GoogleCalendar {
    return GoogleCalendarFromJSONTyped(json, false);
}

export function GoogleCalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCalendar {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'account': GoogleAccountFromJSON(json['account']),
        'summary': json['summary'],
        'description': json['description'],
        'timezone': json['timezone'],
        'enabled': json['enabled'],
    };
}

export function GoogleCalendarToJSON(json: any): GoogleCalendar {
    return GoogleCalendarToJSONTyped(json, false);
}

export function GoogleCalendarToJSONTyped(value?: GoogleCalendar | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account': GoogleAccountToJSON(value['account']),
        'summary': value['summary'],
        'description': value['description'],
        'timezone': value['timezone'],
        'enabled': value['enabled'],
    };
}

